const SuccessIcon = (props: any) => {
  const { insideFill, ...otherProps } = props;
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox='0 0 124 124'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...otherProps}
    >
      <rect
        x='8.57188'
        y='27.0218'
        width='89.9437'
        height='89.9437'
        rx='24.2156'
        fill='url(#paint0_linear_2905_8546)'
        stroke='url(#paint1_linear_2905_8546)'
        strokeWidth='0.76875'
      />
      <g filter='url(#filter0_b_2905_8546)'>
        <rect
          x='25.0996'
          y='6.6499'
          width='90.7125'
          height='90.7125'
          rx='24.6'
          fill='url(#paint2_linear_2905_8546)'
          fillOpacity='0.7'
        />
        <rect
          x='25.484'
          y='7.03428'
          width='89.9437'
          height='89.9437'
          rx='24.2156'
          stroke='url(#paint3_linear_2905_8546)'
          strokeOpacity='0.9'
          strokeWidth='0.76875'
        />
      </g>
      <path
        d='M91.67 44.0083C93.6214 42.0568 93.6214 38.893 91.67 36.9416C89.7186 34.9902 86.5548 34.9902 84.6034 36.9416L65.843 55.702L57.845 47.7041C55.8936 45.7527 52.7298 45.7527 50.7784 47.7041C48.827 49.6555 48.827 52.8194 50.7784 54.7708L62.3096 66.302C64.261 68.2534 67.4249 68.2534 69.3763 66.302L91.67 44.0083Z'
        fill='url(#paint4_linear_2905_8546)'
        stroke='url(#paint5_linear_2905_8546)'
        strokeWidth='0.76875'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <defs>
        <filter
          id='filter0_b_2905_8546'
          x='15.8746'
          y='-2.5751'
          width='109.163'
          height='109.163'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feGaussianBlur in='BackgroundImageFix' stdDeviation='4.6125' />
          <feComposite
            in2='SourceAlpha'
            operator='in'
            result='effect1_backgroundBlur_2905_8546'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_backgroundBlur_2905_8546'
            result='shape'
          />
        </filter>
        <linearGradient
          id='paint0_linear_2905_8546'
          x1='8.1875'
          y1='26.6375'
          x2='98.9'
          y2='117.35'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#317FF5' />
          <stop offset='1' stopColor='#98C1FF' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_2905_8546'
          x1='12.8'
          y1='32.0187'
          x2='90.4437'
          y2='121.194'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#317FF5' stopOpacity='0' />
          <stop offset='1' stopColor='#317FF5' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_2905_8546'
          x1='25.0996'
          y1='6.6499'
          x2='115.812'
          y2='97.3624'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#DCF4FE' />
          <stop offset='1' stopColor='#B0C7E9' />
        </linearGradient>
        <linearGradient
          id='paint3_linear_2905_8546'
          x1='29.7121'
          y1='12.0312'
          x2='107.356'
          y2='101.206'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#C8DEFF' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint4_linear_2905_8546'
          x1='93.518'
          y1='35.0937'
          x2='54.3117'
          y2='55.0812'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#317FF5' />
          <stop offset='1' stopColor='#317FF5' />
        </linearGradient>
        <linearGradient
          id='paint5_linear_2905_8546'
          x1='71.2242'
          y1='35.8624'
          x2='71.2242'
          y2='67.3812'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#317FF5' />
          <stop offset='1' stopColor='#317FF5' stopOpacity='0.7' />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default SuccessIcon;
